// extracted by mini-css-extract-plugin
module.exports = {"image":"SanityImage_image__y7yGb"};